document.addEventListener('DOMContentLoaded', function () {
  /* Reliable muted video autoplay (attributes alone are not always honored) */
  document.querySelectorAll('.lab-hero__video, video[data-autoplay]').forEach(function (v) {
    if (!v || typeof v.play !== 'function') return;
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    v.loop = true;
    var go = function () { v.play().catch(function () {}); };
    go();
    v.addEventListener('canplay', go, { once: true });
  });

  /* Drawer triggers */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-action="open-quote-drawer"]');
    if (trigger && window.CTAPanel && window.CTAPanel.open) {
      e.preventDefault();
      window.CTAPanel.open();
      if (window.CallTrk && window.CallTrk.swap) {
        window.CallTrk.swap();
      }
    }
  });

  /* Accordion / pricing toggles */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-lab-toggle]');
    if (!toggle) return;
    var targetId = toggle.getAttribute('data-lab-toggle');
    var target = document.getElementById(targetId);
    if (!target) return;
    e.preventDefault();
    var isOpen = target.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
});
